import React from 'react';
import { TestimonialCard } from './TestimonialCard';
const TESTIMONIALS = [{
  name: 'Mariana López',
  role: 'Balcón en CABA',
  content: 'Pensé que en mi balcón no podía tener nada. Con el sistema de organización del Manual 1, ahora cosecho tomates y aromáticas todo el año. Increíble.',
  image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&q=80&w=100'
}, {
  name: 'Jorge Martínez',
  role: 'Patio pequeño',
  content: 'Siempre se me secaba todo. Entendí que mi error era el riego y el sustrato. El módulo de control es clarísimo. Ya comimos nuestra primera lechuga.',
  image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&q=80&w=100'
}, {
  name: 'Silvia Fernández',
  role: 'Jubilada',
  content: 'Buscaba algo para entretenerme y ahorrar. El calendario de siembra es mi biblia ahora. No planto nada sin mirarlo. Muy recomendado.',
  image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&q=80&w=100'
}, {
  name: 'Pablo Ruiz',
  role: 'Emprendedor',
  content: 'Compré el Combo 3 porque quería vender plantines. La guía de costos me salvó de perder plata. Hoy ya tengo mis primeros clientes.',
  image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&q=80&w=100'
}, {
  name: 'Carla V.',
  role: 'Principiante',
  content: 'Lo mejor son los bioinsumos. Dejé de gastar en venenos y mis plantas están más sanas que nunca. El manual se paga solo.',
  image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=100'
}];
export function TestimonialsSection() {
  return <section className="py-24 px-4 bg-black" data-id="element-229">
      <div className="max-w-6xl mx-auto" data-id="element-230">
        <div className="text-center mb-16" data-id="element-231">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-232">
            Lo Que Dicen Quienes Ya Lo Aplicaron
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-233">
          {TESTIMONIALS.map((testimonial, index) => <TestimonialCard key={index} {...testimonial} delay={index * 0.1} data-id="element-234" />)}
        </div>
      </div>
    </section>;
}